import { createApi } from "@reduxjs/toolkit/query/react";
import { IClause } from "../../interfaces";
import { CachedBookmarks } from "../../models/responses/bookmarks";
import { axiosBaseQuery } from "../axiosConfig";
import { RequestMethod } from "../enum";
import { suggestionApi } from "../suggestion";
import { bookmarkCacheUpdate } from "./helpers";
import { GetBookmarkRequest, SaveBookmarkRequest } from "./types";

const fetchUserBookmarksQuery = ({ workspaceId, ...args }: GetBookmarkRequest) => ({
  url: "",
  method: RequestMethod.GET,
  params: args,
  workspaceId,
});

const saveBookmarkQuery = ({ workspaceId, ...args }: SaveBookmarkRequest) => ({
  url: "",
  method: RequestMethod.POST,
  data: args,
  workspaceId,
});

export const bookmarksApi = createApi({
  reducerPath: "bookmarks",
  baseQuery: axiosBaseQuery<any>({
    baseUrl: "/bookmarks",
  }),
  endpoints: (build) => ({
    fetchUserBookmarks: build.query<CachedBookmarks, GetBookmarkRequest>({
      query: fetchUserBookmarksQuery,
      transformResponse: ({ bookmarks }: { bookmarks: CachedBookmarks }) => bookmarks,
    }),
    saveBookmark: build.mutation<any, SaveBookmarkRequest>({
      query: saveBookmarkQuery,
      onQueryStarted: async (args, { dispatch, queryFulfilled, getState }) => {
        const optimisticUpdate = dispatch(
          bookmarksApi.util.updateQueryData(
            "fetchUserBookmarks",
            { workspaceId: args.workspaceId },
            bookmarkCacheUpdate(args.bookmark, "ADD")
          )
        );

        try {
          await queryFulfilled;
          const state: any = getState();
          const suggestionSearches = suggestionApi.util.selectCachedArgsForQuery(state, "searchSuggestions");

          suggestionSearches.forEach((searchArgs) => {
            dispatch(
              suggestionApi.util.updateQueryData("searchSuggestions", searchArgs, (data: IClause[]) => {
                const index = data.findIndex((cl) => cl.clause_id === args.bookmark.relatedId);
                if (index > -1) data[index] = { ...data[index], is_bookmarked: Boolean(args.bookmark.bookmark) };
                return data;
              })
            );
          });
        } catch (err) {
          console.error(err);
          optimisticUpdate.undo();
        }
      },
    }),
  }),
});
